<template>
  <v-app style="background-color:#eeeeee">
    

     <div style="padding-top:150px">
           <!-- <v-card flat class="banner" style="border-radius:0px">
               <h1 style="color:white;padding-top:100px;font-size:50px">{{itemList.categoryName}}</h1>
               <h5 style="color:white;">Use Commercial Freezers and Refrigerators to Chill and Display Foods</h5>
           </v-card> -->
                <v-layout row wrap style="padding:20px" v-if="itemList.subCategory.length > 0">
                    <v-flex xs12 sm12 md2 v-for="item in itemList.subCategory" :key="item.id" style="padding:10px">
                        <v-card style="border-radius:0px;padding:0px;" flat color="transparent" class="hvr" @click="detail(item)">
              <img :src=item.src width="100%" height="200px"/>
               <h6 style="text-align:center;padding-top:5px;">{{item.categoryName}}</h6>
            </v-card>
                    </v-flex>
                </v-layout>


                <v-layout row wrap style="padding:20px" v-if="itemList.items.length > 0">
                    <v-flex xs12 sm12 md3 v-for="item in itemList.items" :key="item.id" style="padding:10px">
                        <v-card style="border-radius:0px;padding:10px;" flat color="transparent" class="item">
              <img :src=item.src width="100%" height="200px" @click="detail(item)" class="hvr1"/>
               <h6 style="text-align:center;padding-top:5px;" class="hvr1" @click="detail(item)">{{item.name}}</h6>
              
               <div style="text-align:center">
                   <p>Rating : <v-icon small color="#F3B800">star</v-icon>
                   <v-icon small color="#F3B800">star</v-icon>
                   <v-icon small color="#F3B800">star</v-icon>
                   <v-icon small color="#F3B800">star_half</v-icon>
                   </p>
                   <h4 style="color:#e53935;font-weight:bold">₹{{item.price}}<span style="font-size:12px;color:grey" class="recent">/ Each</span></h4>
                   <v-btn depressed small color="primary" @click="cart(item)">Add To Cart</v-btn>
               </div>
            </v-card>
                    </v-flex>
                </v-layout>
     </div>

            <v-container>
                <p class="recent">{{itemList.description}}</p>
            </v-container>

     
  </v-app>
</template>

<script>
import config from "./../../config.json";
import carousel from 'vue-owl-carousel';
//import VueEasyLightbox from 'vue-easy-lightbox';
import GoTop from '@inotom/vue-go-top';

export default {
  components: {
    GoTop,
    carousel,
  },
  data() {
    return {
      valid: true,
      form: {
        tourPackage: null,
        destination: null
      },

      id: sessionStorage.id,
      itemList: null,
    };
  },
  
   mounted() {
     this.getData();
   },

 methods: {
     getData() {
         this.axios
        .get(config.API + "Home/" + this.id, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.itemList = res.data;
          console.log(this.itemList);
          this.$Progress.finish();
        })
        .catch(err => {
          this.$Progress.fail();
        });
     },

   detail(item) {
       this.axios
        .get(config.API + "Home/" + item.id, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.itemList = res.data;
          console.log(this.itemList);
          this.$Progress.finish();
        })
        .catch(err => {
          this.$Progress.fail();
        });
   },

   cart(item) {
     this.$store.commit('addToCart', item);
     item.available = item.available - 1;
   }
 }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Nanum+Gothic&display=swap');
@import url('https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap');
@import url('https://fonts.googleapis.com/css?family=Anton&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lexend+Tera&family=Open+Sans:wght@600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Metal+Mania&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Patua+One&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Galada&family=Modak&family=Roboto&family=Roboto+Mono:ital,wght@1,600&display=swap');
</style>

<style scoped>
.banner {
  background-image: url('https://cdnimg.webstaurantstore.com/uploads/seo_category/2018/10/commercial-refrigeration_1.jpg');
  background-size: cover;

  height:300px;
}
.hvr:hover {
  cursor: pointer;
  /* height: 200px; */
  border : 2px solid;
  border-color: black !important;
}
.hvr1:hover {
  cursor: pointer;
  text-decoration: underline;
  color: #2196f3;
}
.v-card {
  padding: 10px;
  border-radius: 8px;
}
.v-sheet--offsets {
  top: -50px;
  position: relative;
}
.v-sheet--offset {
  top: -30px;
  position: relative;
}
.v-sheet--offsetf {
  top: -100px;
  position: relative;
}
.swo {
  box-shadow: none !important;
}
.opa {
  opacity: 1;
}
.tourtheme {
  height: 180px;
  margin: 5px;
  background-size: cover;
}
.themecap {
  font-family: 'Open Sans', sans-serif;
  padding-top: 130px;
  color: white;
}
.top-left {
  font-family: 'Roboto Mono', monospace;
  font-size:40px ;
  padding-top: 200px;
  color: white;
  text-align: center;
}
.salont {
  font-family: 'Patua One', cursive;
}
.hvr:hover {
  cursor: pointer;
  /* height: 200px; */
  border : 3px solid;
  border-color: white;
}
.v-table tbody tr:not(:last-child) {
    border-bottom: none !important;
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
img.center {
    display: block;
    margin: 0 auto;
}
.recent {
  font-family: 'Nanum Gothic', sans-serif;
}
.srch {
  position: absolute;
  z-index: 10;
  left: 16%;
  top: 0%;
}
.item {
    border:1px solid !important;
}
</style>
